import {Component, OnInit} from '@angular/core';
import {ClassifierMapping} from '../../models/classifier-mapping.interface';
import {KfConfigurationService} from '../../services/kf-configuration.service';
import {CountryYear} from '../../models/country-year.interface';

@Component({
  selector: 'app-kf-configuration-mapping',
  templateUrl: './kf-configuration-mapping.component.html',
  styleUrls: ['./kf-configuration-mapping.component.scss']
})
export class KfConfigurationMappingComponent implements OnInit {

  constructor(private readonly kfConfigurationService: KfConfigurationService) {
  }

  categorySummaryMappings!: ClassifierMapping[];
  collectionStreamSummaryMappings!: ClassifierMapping[];
  countriesYears!: CountryYear[];
  showCategoryEmptyValues = false;
  showCollectionStreamEmptyValues = false;

  static getCountryYears(data: ClassifierMapping[]): CountryYear[] {
    if (data?.length > 0 && data[0].mappings.length > 0 && data[0].mappings[0]?.countries) {
      return data[0].mappings[0].countries.map(c => ({
        countryCode: c.code,
        countryName: c.name,
        year: c.year
      }));
    }
    return [];
  }

  ngOnInit(): void {
    this.loadCollectionStreamMappingsSummary();
    this.loadCategoryMappingsSummary();
  }

  loadCategoryMappingsSummary(): void {
    this.kfConfigurationService.getCategoriesSummaryMappings(this.showCategoryEmptyValues).subscribe(data => {
      this.countriesYears = KfConfigurationMappingComponent.getCountryYears(data);
      this.categorySummaryMappings = data;
    });
  }

  loadCategoryMappings(event: boolean): void {
    this.showCategoryEmptyValues = event;
    this.kfConfigurationService.getCategoriesSummaryMappings(event).subscribe(data => {
      this.countriesYears = KfConfigurationMappingComponent.getCountryYears(data);
      this.categorySummaryMappings = data;
    });
  }

  loadCollectionStreamMappings(event: boolean): void {
    this.showCollectionStreamEmptyValues = event;
    this.kfConfigurationService.getCollectionStreamsSummaryMappings(event).subscribe(data => {
      this.countriesYears = KfConfigurationMappingComponent.getCountryYears(data);
      this.collectionStreamSummaryMappings = data;
    });
  }

  loadCollectionStreamMappingsSummary(): void {
    this.kfConfigurationService.getCollectionStreamsSummaryMappings(this.showCollectionStreamEmptyValues).subscribe(data => {
      this.countriesYears = KfConfigurationMappingComponent.getCountryYears(data);
      this.collectionStreamSummaryMappings = data;
    });
  }

  downloadCategorySummaryExcel(event: boolean): void {
    this.kfConfigurationService.getCategoriesSummaryMappingsExcel(event).subscribe(response => {
      const blob = new Blob([response.body], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    });
  }

  downloadCollectionStreamSummaryExcel(event: boolean): void {
    this.kfConfigurationService.getCollectionStreamsSummaryMappingsExcel(event).subscribe(response => {
      const blob = new Blob([response.body], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    });
  }
}
